import localeCode from 'iso-639-1'

export interface Translations {
  [id:string]: string,
}

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import resources from "./resources";

i18n
  .use( initReactI18next )
  .init({
    resources: resources,
    lng: 'en',
    debug: false,

    // Default Namespace
    defaultNS: 'common',
    fallbackLng: {

      // https://www.i18next.com/principles/fallback#fallback-to-different-languages
      // For the time being let's fallback always back to english
      // Better than to fallback to the keyname itself

      default: [ 'en' ],
    },
    fallbackNS: 'common',

    interpolation: {
      escapeValue: false,
    }
  });

export type LanguageCode = 'en' | 'de' | 'sv' | 'fi' | 'da' | 'nb' | 'cs' | 'el' | 'es' | 'fr' | 'hu' | 'it' | 'nl' | 'pl' | 'pt' | 'ro' | 'sk' | 'tr';

export interface LanguageType {
  code: LanguageCode,
  language: string,
}

type Dialects = {
  [key: string]: string;
};

export const dialects: Dialects = {
  nn: "nb",
  no: "nb",
  nb: "nb",
  en: "en",
  de: "de",
  da: "da",
  fi: "fi",
  sv: "sv",
  cs: 'cs',
  el: 'el',
  es: 'es',
  fr: 'fr',
  hu: 'hu',
  it: 'it',
  nl: 'nl',
  pl: 'pl',
  pt: 'pt',
  ro: 'ro',
  sk: 'sk',
  tr: 'tr',
}

function capitalizeFirstLetter(name: string) {
  return name.charAt(0).toUpperCase() + name.slice(1);
}


export const languageTypes: LanguageType[] = [
  {
    code: "en",
    language: capitalizeFirstLetter(localeCode.getNativeName('en'))
  },
  {
    code: "de",
    language: capitalizeFirstLetter(localeCode.getNativeName('de'))
  },
  {
    code: "sv",
    language: capitalizeFirstLetter(localeCode.getNativeName('sv'))
  },
  {
    code: "fi",
    language: capitalizeFirstLetter(localeCode.getNativeName('fi'))
  },
  {
    code: "da",
    language: capitalizeFirstLetter(localeCode.getNativeName('da'))
  },
  {
    code: "nb",
    language: capitalizeFirstLetter(localeCode.getNativeName('nb'))
  },
  {
    code: "cs",
    language: capitalizeFirstLetter(localeCode.getNativeName('cs'))
  },
  {
    code: "el",
    language: capitalizeFirstLetter(localeCode.getNativeName('el'))
  },
  {
    code: "es",
    language: capitalizeFirstLetter(localeCode.getNativeName('es'))
  },
  {
    code: "fr",
    language: capitalizeFirstLetter(localeCode.getNativeName('fr'))
  },
  {
    code: "hu",
    language: capitalizeFirstLetter(localeCode.getNativeName('hu'))
  },
  {
    code: "it",
    language: capitalizeFirstLetter(localeCode.getNativeName('it'))
  },
  {
    code: "nl",
    language: capitalizeFirstLetter(localeCode.getNativeName('nl'))
  },
  {
    code: "pl",
    language: capitalizeFirstLetter(localeCode.getNativeName('pl'))
  },
  {
    code: "pt",
    language: capitalizeFirstLetter(localeCode.getNativeName('pt'))
  },
  {
    code: "ro",
    language: capitalizeFirstLetter(localeCode.getNativeName('ro'))
  },
  {
    code: "sk",
    language: capitalizeFirstLetter(localeCode.getNativeName('sk'))
  },
  {
    code: "tr",
    language: capitalizeFirstLetter(localeCode.getNativeName('tr'))
  }
]

export default i18n;
